import React from 'react';

import {
  IStyleFunctionOrObject,
  ITextFieldStyleProps,
  ITextFieldStyles,
  PartialTheme,
  registerIcons,
} from '@fluentui/react';
import {
  CancelIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@fluentui/react-icons-mdl2';
import { Icon } from 'semantic-ui-react';
import { theme } from '../styles/theme';

registerIcons({
  icons: {
    ChevronDown: <ChevronDownIcon />,
    ChevronLeft: <Icon name="caret left" />,
    ChevronRight: <Icon name="caret right" />,
    ChevronUp: <ChevronUpIcon />,
    Cancel: <CancelIcon />,
  },
});

const textFieldStyles: IStyleFunctionOrObject<
  ITextFieldStyleProps,
  ITextFieldStyles
> = {
  fieldGroup: {
    '&::after': {
      borderWidth: 1,
    },
  },
};

export const fluentuiTheme: PartialTheme = {
  // inherit our custom font styles
  defaultFontStyle: {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    color: 'inherit',
  },
  components: {
    ContextualMenu: {
      styles: {
        root: {
          borderRadius: 0,
          backgroundColor: 'unset',
        },
      },
    },
    CalloutContent: {
      styles: {
        calloutMain: {
          overflow: 'initial', // allow content of the callout to overflow (e.g. date panels in Create Event popups
          borderRadius: 0,
          backgroundColor: 'unset',
        },
        root: {
          animation: 'unset',
          font: 'inherit',
          color: 'inherit',
          borderRadius: 0,
          boxShadow: 'unset',
        },
      },
    },
    TextField: {
      styles: textFieldStyles,
    },
  },
  // generated at https://www.aka.ms/themedesigner
  // from colors.mainBlue as "Primary color" and colors.grey2 as "Text Color"
  palette: {
    themePrimary: theme.colors.mainBlue,
    themeLighterAlt: '#f4f9fe',
    themeLighter: '#d3e8fc',
    themeLight: '#aed4f9',
    themeTertiary: '#61aaf3',
    themeSecondary: '#1c85ed',
    themeDarkAlt: '#006ad3',
    themeDark: '#0059b2',
    themeDarker: '#004283',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#cfcfd1',
    neutralSecondary: '#9f9fa3',
    neutralSecondaryAlt: '#9f9fa3',
    neutralPrimaryAlt: '#747478',
    neutralPrimary: '#626266',
    neutralDark: '#4a4a4e',
    black: '#373739',
    white: '#ffffff',
  },
};
